const mutations = {
    setCode: (state, code) => {
        state.code = code
    },
};

export default mutations;